'use client'

import { useEffect, useState } from 'react'
import { authFormStore } from '@view/auth/model'
import { observer } from 'mobx-react-lite'

interface ResendCodeProps {
  onResend: () => void
  disabled?: boolean
}

const formatCountdown = (totalSeconds: number) => {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${String(seconds).padStart(2, '0')}`
}

export const ResendCode = observer(({ onResend, disabled }: ResendCodeProps) => {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const timerId = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(timerId)
  }, [])

  const secondsLeft = Math.max(0, Math.ceil((authFormStore.resendAvailableAt - now) / 1000))
  const isCoolingDown = secondsLeft > 0

  return (
    <p className="text-center text-sm text-gray-500 dark:text-gray-400">
      Не получили код?{' '}
      {isCoolingDown ? (
        <span className="text-gray-400">Отправить повторно через {formatCountdown(secondsLeft)}</span>
      ) : (
        <button
          type="button"
          disabled={disabled}
          onClick={onResend}
          className="link font-semibold disabled:cursor-not-allowed disabled:opacity-60"
        >
          Отправить повторно
        </button>
      )}
    </p>
  )
})
